import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { ILookupBase } from '../../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { FormPermissionToAssessService } from "../../../../Services/FormPermissionToAssessService";
import { IFormPermissionToAssess } from "../../../../Models/Forms/IFormPermissionToAssess"
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'PermissionToAssess',
  templateUrl: './PermissionToAssess.component.html',
  styleUrls: ['./PermissionToAssess.component.css']

})
export class FormPermissionToAssessComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  formPermissionToAssessDB: any = [];
  _lookupService: LookupService;
  _lookupAssessorType: ILookupBase[];
  selectedAcademicAchievementIds: any[];
  selectedHealthIds: any[];
  selectedIntellectualDevelopmentIds: any[];
  selectedLanguageDevelopmentIds: any[];
  selectedMotorDevelopmentIds: any[];
  selectedSocialBehaviorIds: any[];
  selectedAdaptiveBehaviorIds: any[];
  selectedPostSecondaryTransitionIds: any[];
  selectedAudiologicalAssessmentIds: any[];
  selectedPhysicalTherapyIds: any[];
  selectedOtherIds: any[];
  selectedAlternativeAssessmentIds: any[];
  checkedTrue: boolean;
  checkedFalse: boolean;
  reportParamArray: IReportParameter[];
  twoYearsBackDate: Date;

  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _frmPermissionToAssessService: FormPermissionToAssessService) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService
    this.checkedTrue = true;
    this.checkedFalse = false
  }

  ngOnInit(): void {
    this.LoadFormPermissionToAssessDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    let mtgDate = this._myGlobals.selectedIepInstance.meetingDate;
    this.twoYearsBackDate = new Date(mtgDate.getFullYear() - 2, mtgDate.getMonth(), mtgDate.getDate());
  }

  LoadFormPermissionToAssessDetails(): void {
    this._frmPermissionToAssessService.getFormPermissionToAssess(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormPermissionToAssess) => {
        this.formPermissionToAssessDB = res,
          this.setSelectedListboxValues();
        this.LoadLookupValues()
        this.formPermissionToAssessDB.currentAssementPlanDate = this.formPermissionToAssessDB.currentAssementPlanDate == null ? null : new Date(this.formPermissionToAssessDB.currentAssementPlanDate);
        this.formPermissionToAssessDB.dateReceivedAtSchool = this.formPermissionToAssessDB.dateReceivedAtSchool == null ? null : new Date(this.formPermissionToAssessDB.dateReceivedAtSchool);
        this.formPermissionToAssessDB.extensionRequestedDate = this.formPermissionToAssessDB.extensionRequestedDate == null ? null : new Date(this.formPermissionToAssessDB.extensionRequestedDate);
        this.formPermissionToAssessDB.requestedOn = this.formPermissionToAssessDB.requestedOn == null ? null : new Date(this.formPermissionToAssessDB.requestedOn);
        this.formPermissionToAssessDB.firstMailingDate = this.formPermissionToAssessDB.firstMailingDate == null ? null : new Date(this.formPermissionToAssessDB.firstMailingDate);
        this.formPermissionToAssessDB.secondMailingDate = this.formPermissionToAssessDB.secondMailingDate == null ? null : new Date(this.formPermissionToAssessDB.secondMailingDate);
        this.formPermissionToAssessDB.thirdMailingDate = this.formPermissionToAssessDB.thirdMailingDate == null ? null : new Date(this.formPermissionToAssessDB.thirdMailingDate);
        this.formPermissionToAssessDB.signatureDate = this.formPermissionToAssessDB.signatureDate == null ? null : new Date(this.formPermissionToAssessDB.signatureDate);
        this.formPermissionToAssessDB.mediCalInfoReleaseDate = this.formPermissionToAssessDB.mediCalInfoReleaseDate == null ? null : new Date(this.formPermissionToAssessDB.mediCalInfoReleaseDate);      
      },
        //err => console.error(err)
        (err) => {
          console.error(err);
        }
      );
  }

  setSelectedListboxValues() {
    if (this.formPermissionToAssessDB.academicPreAcademicAchievementExaminer != null) {
      this.selectedAcademicAchievementIds = this.formPermissionToAssessDB.academicPreAcademicAchievementExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.healthExaminer != null) {
      this.selectedHealthIds = this.formPermissionToAssessDB.healthExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.cognitiveDevelopmentExaminer != null) {
      this.selectedIntellectualDevelopmentIds = this.formPermissionToAssessDB.cognitiveDevelopmentExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.languageSpeechCommunicationExaminer != null) {
      this.selectedLanguageDevelopmentIds = this.formPermissionToAssessDB.languageSpeechCommunicationExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.motorDevelopmentExaminer != null) {
      this.selectedMotorDevelopmentIds = this.formPermissionToAssessDB.motorDevelopmentExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.socialAdaptiveBehaviorExaminer != null) {
      this.selectedSocialBehaviorIds = this.formPermissionToAssessDB.socialAdaptiveBehaviorExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.adaptiveBehaviorExaminer != null) {
      this.selectedAdaptiveBehaviorIds = this.formPermissionToAssessDB.adaptiveBehaviorExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.postSecondaryTransitionExaminer != null) {
      this.selectedPostSecondaryTransitionIds = this.formPermissionToAssessDB.postSecondaryTransitionExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.audiologicalExaminer != null) {
      this.selectedAudiologicalAssessmentIds = this.formPermissionToAssessDB.audiologicalExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.physicalTherapyExaminer != null) {
      this.selectedPhysicalTherapyIds = this.formPermissionToAssessDB.physicalTherapyExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.otherExaminer != null) {
      this.selectedOtherIds = this.formPermissionToAssessDB.otherExaminer.map(String);
    }
    if (this.formPermissionToAssessDB.alternateMeansOfAssessmentExaminer != null) {
      this.selectedAlternativeAssessmentIds = this.formPermissionToAssessDB.alternateMeansOfAssessmentExaminer.map(String);
    }
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.AssessorType]).subscribe((res: ILookupBase[]) => {
      this._lookupAssessorType = res;
    },
      err => console.error(err)
    );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  SaveSelectedListboxValues() {
    this.formPermissionToAssessDB.academicPreAcademicAchievementExaminer = this.selectedAcademicAchievementIds;
    this.formPermissionToAssessDB.healthExaminer = this.selectedHealthIds;
    this.formPermissionToAssessDB.cognitiveDevelopmentExaminer = this.selectedIntellectualDevelopmentIds;
    this.formPermissionToAssessDB.languageSpeechCommunicationExaminer = this.selectedLanguageDevelopmentIds;
    this.formPermissionToAssessDB.motorDevelopmentExaminer = this.selectedMotorDevelopmentIds;
    this.formPermissionToAssessDB.socialAdaptiveBehaviorExaminer = this.selectedSocialBehaviorIds;
    this.formPermissionToAssessDB.adaptiveBehaviorExaminer = this.selectedAdaptiveBehaviorIds;
    this.formPermissionToAssessDB.postSecondaryTransitionExaminer = this.selectedPostSecondaryTransitionIds;
    this.formPermissionToAssessDB.audiologicalExaminer = this.selectedAudiologicalAssessmentIds;
    this.formPermissionToAssessDB.physicalTherapyExaminer = this.selectedPhysicalTherapyIds;
    this.formPermissionToAssessDB.otherExaminer = this.selectedOtherIds;
    this.formPermissionToAssessDB.alternateMeansOfAssessmentExaminer = this.selectedAlternativeAssessmentIds;
  }

  //Save the
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.SaveSelectedListboxValues()

    //update values
    this._frmPermissionToAssessService.insertUpdateFormPermissionToAssess(this.formPermissionToAssessDB)
      .subscribe((res: IFormPermissionToAssess) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.LoadFormPermissionToAssessDetails();
        this.validateForm();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._frmPermissionToAssessService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  checkMailingDates() {
    this.clearMessages();
    let pta = this.formPermissionToAssessDB as IFormPermissionToAssess;
    if (pta.firstMailingDate != null && pta.secondMailingDate != null && pta.secondMailingDate <= pta.firstMailingDate) {
      let failedMessage: Message = { severity: 'error', summary: 'The second mailing date must be after the first mailing date.' }
      this.addMessage(failedMessage);
    }
    if (pta.secondMailingDate != null && pta.thirdMailingDate != null && pta.thirdMailingDate <= pta.secondMailingDate) {
      let failedMessage: Message = { severity: 'error', summary: 'The third mailing date must be after the second mailing date.' }
      this.addMessage(failedMessage);
    }
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormPermissionToAssessDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formPermissionToAssessDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.formPermissionToAssessDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      //{ parameterName: 'PlanAddendumID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'False' },
      { parameterName: 'PermissionToAssessId', parameterValue: this.formPermissionToAssessDB.id.toString() },
      { parameterName: 'IEPID', parameterValue: this.formPermissionToAssessDB.iepId.toString() }
      //{ parameterName: 'PageNumber', parameterValue: '' },
      //{ parameterName: 'ShowWatermark', parameterValue: 'False' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formPermissionToAssessDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formPermissionToAssessDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
